import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import StarsBackground from './StarsBackground';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const authRoutes = ['/login', '/signup', '/forgot-password', '/reset-password'];
  const isAuthPage = authRoutes.includes(location.pathname);
  const isLandingPage = location.pathname === '/';

  // Measure the real viewport height and set as CSS variable.
  // This fixes Android WebView where CSS 100vh !== actual viewport height.
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setVH();
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);
    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);

  // Dynamically set body/html background to match auth pages.
  useEffect(() => {
    // Rely on index.css for all backgrounds now.
    // Removed legacy body background overrides here.
  }, [isAuthPage]);

  return (
    <div className={`layout ${isAuthPage ? 'auth-layout' : ''} ${isLandingPage ? 'landing-layout' : ''}`}>
      {!isLandingPage && <StarsBackground />}
      {!isLandingPage && <Header />}
      <main className={isLandingPage ? 'w-full' : 'main-content'}>
        {children}
      </main>
      {!isLandingPage && (
        <footer className="footer">
          <div className="container">
            <p>&copy; 2026 AstroML Bot. All rights reserved.</p>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Layout;

